import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Moduels/Context/AuthContext";
import { useFoundationSetup } from "../../Moduels/Context/FoundationSetupContext";

function missingLabels(status) {
  const missing = [];
  if (!status.departmentsCount) missing.push("departments");
  if (!status.designationsCount) missing.push("designations");
  if (!status.locationsCount) missing.push("locations");
  return missing;
}

export default function SetupIncompleteBanner({ compact = false, className = "" }) {
  const { role } = useContext(AuthContext);
  const ctx = useFoundationSetup();
  const isAdmin = ["admin", "superadmin", "super_admin"].includes(String(role || "").toLowerCase());

  if (!ctx || ctx.status.loading || ctx.status.complete) return null;

  const missing = missingLabels(ctx.status);
  const detail = missing.join(", ");

  if (compact) {
    return (
      <div
        className={`flex flex-wrap items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 ${className}`}
        role="status"
      >
        <span>
          Initial setup incomplete — add {detail} or finish{" "}
          {isAdmin ? (
            <Link to="/Setup" className="font-semibold text-blue-800 underline hover:text-blue-900">
              Organisation Setup
            </Link>
          ) : (
            "organisation setup (ask your admin)"
          )}
          .
        </span>
      </div>
    );
  }

  return (
    <div
      className={`rounded-xl border border-amber-300 bg-gradient-to-r from-amber-50 to-orange-50 px-4 py-3 shadow-sm ${className}`}
      role="alert"
    >
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-semibold text-amber-950">Initial setup not finished</p>
          <p className="mt-0.5 text-sm text-amber-900/90">
            You can still add employees, but you need at least one of each:{" "}
            <strong>{detail}</strong>. Use the quick-add links below each field, or complete the full setup.
          </p>
        </div>
        {isAdmin && (
          <Link
            to="/Setup"
            className="inline-flex shrink-0 items-center justify-center rounded-lg bg-blue-800 px-4 py-2 text-sm font-semibold text-white shadow hover:bg-blue-900"
          >
            Go to Initial Setup →
          </Link>
        )}
      </div>
    </div>
  );
}
